export default "__VITE_ASSET__BB$_6I0c__"